import type { ReactNode } from 'react'
import Editable from './Editable'
import { colorOptions } from '../home/options'
import { usePalette } from '@/state/usePalette'

const colorFields = [
  { label: 'Primary', index: 0 },
  { label: 'Secondary', index: 1 },
  { label: 'Tertiary', index: 2 },
] as const

/** The Colors note: primary, secondary and tertiary pickers over the mission's own colors. */
export default function ColorsNote({ children, enabled, className }: { children: ReactNode; enabled: boolean; className?: string }) {
  const { colors, custom, update, reset, customize } = usePalette()
  return (
    <Editable
      label="Palette"
      value={custom ? 'custom' : 'mission'}
      options={colorOptions}
      onChange={(value) => (value === 'custom' ? customize() : reset())}
      token="palette"
      detail="Every light and dark role is derived from these three colors and adjusted to meet WCAG AA contrast."
      pin="below-center"
      as="span"
      className={className}
      enabled={enabled}
      extra={
        <span className="mds-color-fields">
          {colorFields.map((field) => (
            <label key={field.label} className="mds-color-field">
              <input type="color" value={colors[field.index]} onChange={(event) => update(field.index, event.target.value)} />
              <span>{field.label}</span>
              <code>{colors[field.index]}</code>
            </label>
          ))}
        </span>
      }
    >
      {children}
    </Editable>
  )
}
